import { render, staticRenderFns } from "./TipoCaracteristicaList.vue?vue&type=template&id=30ab9be2"
import script from "./TipoCaracteristicaList.vue?vue&type=script&lang=js"
export * from "./TipoCaracteristicaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports